import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import { environment } from '../../../environments/environment';
import {GetResponse, PostResponse} from '@app/shared';

@Injectable({
  providedIn: 'root',
})
export class CurrencyService {
  private currencyUrl = environment.financeApiBaseUrl + '/api/currency';
  private currencyExchangeUrl =
    environment.financeApiBaseUrl + '/api/currencyExchange';

  constructor(private http: HttpClient) {}

  getCurrency(params: any, accessToken?: string): Observable<any> {
    let headers = new HttpHeaders();

    // Si el accessToken es proporcionado, agregamos el header Authorization
    if (accessToken) {
      headers = headers.set('Authorization', `Bearer ${accessToken}`);
    }

    return this.http
      .get<GetResponse>(this.currencyUrl, { params, headers: headers })
  }

  createCurrency(data: any): Observable<any> {
    return this.http
      .post<PostResponse>(this.currencyUrl + '/form', data)
  }

  updateCurrency(data: any): Observable<any> {
    return this.http
      .put<PostResponse>(this.currencyUrl + '/form', data)
  }

  patchCurrency(data: any): Observable<any> {
    return this.http
      .patch<PostResponse>(this.currencyUrl + '/form', data)
  }

  deleteCurrency(ids: number[]): Observable<any> {
    return this.http
      .delete<PostResponse>(`${this.currencyUrl}`, { params: { ids: ids } })
  }

  // Add methods for CurrencyExchange
  getCurrencyExchange(params: any, accessToken?: string): Observable<any> {
    let headers = new HttpHeaders();

    // El PDF se renderiza sin sesión: necesita mandar el token explícitamente
    if (accessToken) {
      headers = headers.set('Authorization', `Bearer ${accessToken}`);
    }

    return this.http
      .get(`${this.currencyExchangeUrl}`, { params, headers });
  }

  createCurrencyExchange(data: any): Observable<any> {
    return this.http
      .post(`${this.currencyExchangeUrl}`, data);
  }

  updateCurrencyExchange(data: any): Observable<any> {
    return this.http
      .put(`${this.currencyExchangeUrl}`, data);
  }

  deleteCurrencyExchange(ids: number[]): Observable<any> {
    return this.http
      .delete(`${this.currencyExchangeUrl}`, { params: { ids: ids } });
  }
}
